// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Tabby from 'tabbyjs/dist/js/tabby.min';

export default class Tabs extends WebComponent {
  didMount() {

    this.tabs = new Tabby('[data-is="FulltextTabs"]');

    if (this.tabs) {
      setTimeout(() => {
        const tabbyContent = document.querySelector('.fulltext-results-container');
        if (tabbyContent) tabbyContent.classList.remove('fulltext-results-container--hidden');
        const tabsItems = document.querySelectorAll('.fulltext-anchors__link');

        const urlString = window.location.href;
        const url = new URL(urlString);
        const section = url.searchParams.get('section');

        if (tabsItems) {
          if (section) {
            const preferedItem = document.getElementById(`tabby-toggle_${ section }`);
            preferedItem.click(); // click on prefered tab (link form Autocomplete section)
          } else {
            let containsProductsResults = false;
            tabsItems.forEach((item, index) => {
              const attr = item.getAttribute('href');
              if (attr === '#dynamicArea') {
                containsProductsResults = true;
              }
            });
            if (containsProductsResults) {
              const productTab = document.querySelector('[aria-controls=dynamicArea]');// find product tab
              productTab.click(); // and click o it
            } else {
              tabsItems[0].click(); // first item click
            }
          }
        }

        const locationSearch = location.search.split('=');
        if  (typeof locationSearch[1] != 'undefined') {
          const target = document.getElementById(locationSearch[1]);
          target.scrollIntoView({behavior: 'smooth'});
        }

      }, 200);

      document.addEventListener('tabby', (event) => {
        const content = event.detail.content;
        content.classList.remove('hidden');
      }, false);
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FulltextTabs.js